import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { ShoppingCartIcon } from '@root/styles/icons';
import { useTranslations } from '@lang';

import getContrastFontColor from '@utils/getContrastFontColor';

const BasketIconWrapper = styled.span`
  position: relative;
  font-size: 13px;
  height: 24px;
`;

const BasketIcon = styled.span`
  background: #ffffff;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) =>
    getContrastFontColor(
      theme.customColors.header,
      theme.defaultColors.fontPrimary,
      theme.defaultColors.lighterGrey
    )};
  width: 18px;
  height: 18px;
  line-height: 16px;
  border-radius: 50%;
  position: absolute;
  right: -5px;
  top: -5px;
  text-align: center;
`;

const BasketIconText = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.customColors.navigationAndFooter};
`;

const BasketIndicator = ({ basketCount }) => {
  const { t } = useTranslations();

  return (
    <BasketIconWrapper aria-label={t('aria.basket')}>
      {!!basketCount && (
        <BasketIcon>
          <BasketIconText>{basketCount}</BasketIconText>
        </BasketIcon>
      )}
      <ShoppingCartIcon />
    </BasketIconWrapper>
  );
};

BasketIndicator.propTypes = {
  basketCount: PropTypes.number.isRequired,
};

export default BasketIndicator;
